var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSection42(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.3 30.6c.7-3 2.8-4.7 5.8-5 2-.2 2-3.4 0-3.2-4.4.4-8 2.9-8.9 7.3-.4 2 2.7 2.9 3.1.9z",
    fill: "#1E2882"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8 55.9c.7-.1 3 0 2.8.7-.2.3-.3.8-.6 1-3.7 1.7-8 2-12.1 2s-8.2-.4-12.3-1c-2.7-.4-9.2 0-9.6-.4-.4-.2-.7-2.3-.1-2.3 3 .3 10.8.6 14.8.8 0 0 1-6.2.9-7l-.7-4.1c-2.3 0-6.2-1-8-2.6-2-1.7-3.6-3.7-5-6A38.2 38.2 0 0117.2 16c1.3-.7 2.7-1.3 4.1-1.7a95.6 95.6 0 0128.4-2.1c2.1 0 3.9 1 5.7 2.2.5 7.3 1.2 14.3-1.5 21.2a19 19 0 01-5.8 8.2 28.6 28.6 0 01-9.6 2.7l-.2 4.2L38 57l11.8-1.1z",
    fill: "#B8DDF0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8 57.5c2.4-.2-.4-.5-1.4-.4-1.3.2-2.6.6-4 .7-2.7.3-5.5.3-8.2.1-4.4-.2-8.7-1-13.1-1.1-1.2 0-3.2-.4-4.3 0-.5 0-.3 0 .4.3-1 .4-1.1.6-.2.5.7.2 1.4.2 2.1.2l11.6.5a1.6 1.6 0 001.5-1.2c.7-4.3 1-7.7.3-12a1.6 1.6 0 00-1.6-1.2c-14-.6-15-17.5-14.1-28l-.8 1.4c5-2.7 11.3-3.2 16.9-3.6 6.1-.5 14.2-1.4 19.6 2l-.8-1.4c.6 7.9 1.4 16.4-2.8 23.6-2.9 5-7 6.2-12.5 6.9a1.7 1.7 0 00-1.6 1.6c0 3.5-.2 7-.4 10.6a1.6 1.6 0 001.6 1.6l11.8-1.1c2-.3 2-3.5 0-3.3-4 .5-7.8.8-11.8 1.1l1.7 1.7c0-3.6.2-7.1.4-10.6L38.4 48c2.6-.3 5.1-.8 7.6-1.6 3.6-1.2 6.1-4 8-7.4 2.4-4.4 3.3-9.5 3.4-14.5 0-2.7-.1-5.3-.3-8-.2-2.4-.1-3.2-2.4-4.4-4.2-2.3-9.3-1.9-14-1.8a90 90 0 00-21 2.7c-1 .4-3 .9-3.7 1.8-1 1.2-.6 3.7-.7 5.2-.1 2.8 0 5.6.3 8.4 1.3 9.4 7 18.3 17.3 18.8L31.4 46c.4 3.4.4 6.9-.3 10.3l1.6-1.2-10-.5c-1.6 0-5.1-1-6.3.5-1 1.1-.5 3.7.8 4.5 1.5 1 4.6.4 6.3.4 8 0 15.6 2 23.6.6 2.1-.3 7-1 7-4 0-2.3-2.7-2.5-4.3-2.4-2 .1-2 3.4 0 3.3z",
    fill: "#B8DDF0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3 36.9c3.1 1.5 6.6 2 10 1.4 2-.5 1.2-3.6-.8-3.1a12 12 0 01-7.6-1.1c-1.8-1-3.4 1.8-1.6 2.7zM59.3 25c1.7.6 3.5 1.8 3.4 3.8a4.6 4.6 0 01-2.7 3.8c-1.9.9-.3 3.7 1.6 2.7a7.7 7.7 0 004.3-7.1c-.2-3.3-3-5.3-5.8-6.4-1.9-.7-2.7 2.4-.8 3.1z",
    fill: "#FFD15A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4 23.9c1.6.2 3.1.7 4.5 1.4 1.9.9 3.5-1.9 1.6-2.8-1.9-1-4-1.6-6-1.9-2.1-.1-2.1 3.1 0 3.3z",
    fill: "#1E2882"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8 37a16 16 0 006.8-1.5c.8-.4 1-1.6.6-2.2a1.6 1.6 0 00-2.2-.6c-1.7.7-3.4 1.1-5.2 1.1-2 0-2 3.2 0 3.2z",
    fill: "#009AFA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4 33.7c-1-.6-1.3-2-1-3.1.3-2-2.8-3-3.2-.9-.5 2.5.2 5.4 2.5 6.8 1.9 1 3.5-1.8 1.7-2.8z",
    fill: "#1E2882"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7 61.2a15 15 0 006-2.1c1.7-1.2.1-4-1.6-2.8-1.6 1-3.4 1.6-5.3 1.8-2 .4-1.1 3.5.9 3.1zM17.4 60c3 1.2 6.8 1.4 10 1.7 4 .5 8 .6 12 .4 2-.2 2-3.4 0-3.3-3.7.3-7.4.2-11.1-.2-3.3-.3-7-.5-10-1.8-2-.8-2.7 2.3-.9 3.1zM30 47.8v6c-.1 2 3 2 3.2 0v-6c-.1-2-3.3-2-3.2 0z",
    fill: "#009AFA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7 38.5h3.9c2 0 2-3.3 0-3.3-1.3 0-2.6.2-3.9.1a1.6 1.6 0 00-1.6 1.6 1.6 1.6 0 001.6 1.6z",
    fill: "#1E2882"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4 24c4.2-.5 7-.3 11-.2l-11 .2z",
    fill: "#FFD15A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4 26.6a75 75 0 0111-.2c3.4 0 3.4-5 0-5.1a75 75 0 00-11 .2c-3.2.3-3.2 5.5 0 5.1z",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36 24.7c.3 4.7.8 8.8.6 13.5l-.5-13.5z",
    fill: "#FFD15A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 24.7c.2 4.5.6 9 .5 13.5 0 3.3 5.1 3.3 5.2 0 0-4.5-.3-9-.6-13.5-.1-3.3-5.2-3.4-5 0z",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M31 37.8c3.8.3 7.5.7 11.2 0H31z",
    fill: "#FFD15A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M31 40.4c4 .3 7.9.6 11.9 0 3.2-.6 1.9-5.5-1.4-5-3.5.5-7 .1-10.5-.1-3.3-.2-3.3 4.9 0 5.1zM17.8 15.9c6.4 1.3 23.3 1 29.2.4 2.6-.4 5.1-1 7.7-1.6.7 0 .5-1-.1-1.2C53 13 51.3 12.1 50 12c-10.3-1-17.7-.5-28 1-1.6.4-3.2 1-4.6 1.9-.4.3-.2 1 .4 1",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4 17.4a99.4 99.4 0 0020.7 1c3 0 6-.2 8.9-.5 2.7-.3 6.6-.5 9-2.1a1.6 1.6 0 00.7-1.4c-.5-3.6-6.2-4-9-4.2-5.5-.5-11-.4-16.5 0-4.4.5-10 .5-14 3-1.8 1-2.4 4 .6 4.3 2 .2 2-3 0-3.2l1.1 1.6.8-.4c.7-.1 1.3-.6 2-.8a117.7 117.7 0 0123-1.5c1.7 0 3.3.2 5 .4.4 0 3.9 1.2 3.8.8l.8-1.4c-2 1.3-6 1.5-8.3 1.8-2.9.3-5.8.4-8.7.4-6.3.1-12.9.3-19.1-.9-2-.3-2.9 2.8-.9 3.1z",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M17 37.2c1.2 6 8.9 11.3 14.7 12 2 .2 2-3 0-3.2-4.5-.5-10.7-5.1-11.6-9.7-.4-2-3.5-1.1-3 .9z",
    fill: "#1E2882"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4 16.6c.9-3.3 7.7-2.9 10-3.1 4.4-.4 8.7-.5 13-.5 2.1 0 2.1-3.2 0-3.2-6.2-.1-12.5.2-18.6 1-3 .4-6.6 1.8-7.5 5-.5 2 2.6 2.8 3.1.8z",
    fill: "#F68559"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8 13.5c1.9.1 4.1.2 5.2 2 1.1 1.7 4 0 2.8-1.7-1.8-2.8-4.9-3.3-8-3.5-2-.2-2 3 0 3.2z",
    fill: "#1E2882"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection42);
export default __webpack_public_path__ + "static/media/section4-2.b5bcb19a79f18ad86da54369cfdab304.svg";
export { ForwardRef as ReactComponent };